module.exports = __webpack_public_path__ + "img/GH-kyujin-top-osusume014.497f9c1e.webp";